module.exports = __webpack_public_path__ + "static/media/pimpmyride.c5a298b4.mp3";